import React, { useState } from "react";
import Autosuggest from "react-autosuggest";

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str: any) {
	return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function getSuggestions(value: any, suggestions: any) {
	const escapedValue = escapeRegexCharacters(value.trim());

	if (escapedValue === "") {
		return [];
	}

	const regex = new RegExp("^" + escapedValue, "i");

	return suggestions.filter((suggestion: any) => regex.test(suggestion.name));
}

function getSuggestionValue(suggestion: any) {
	return suggestion.name;
}

function renderSuggestion(suggestion: any) {
	return <span>{suggestion.name}</span>;
}

const theme = {
	input: {},
	container: {
		position: "relative",
	},
	inputFocused: {
		outline: "none",
	},
	inputOpen: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},
	suggestionsContainer: {
		display: "none",
	},
	suggestionsContainerOpen: {
		display: "block",
		position: "absolute",
		top: 51,
		width: 280,
		border: "1px solid #aaa",
		backgroundColor: "#fff",
		fontFamily: "Helvetica, sans-serif",
		fontWeight: 300,
		fontSize: 16,
		borderBottomLeftRadius: 4,
		borderBottomRightRadius: 4,
		zIndex: 2,
	},
	suggestionsList: {
		margin: 0,
		padding: 0,
		listStyleType: "none",
	},
	suggestion: {
		cursor: "pointer",
		padding: "10px 20px",
	},
	suggestionHighlighted: {
		backgroundColor: "#ddd",
	},
};

const AutoComplete = (props: any) => {
	const [value, setValue] = useState("");
	const [suggestions, setSuggestions] = useState([]);

	const onChange = (_: any, { newValue }: any) => {
		setValue(newValue);
		props.onChange(newValue);
	};

	const onSuggestionsFetchRequested = ({ value: v }: any) => {
		setSuggestions(getSuggestions(v, props.suggestions));
	};

	const onSuggestionsClearRequested = () => {
		setSuggestions([]);
	};

	const inputProps = {
		placeholder: "",
		className: "form-control form-control-lg",
		value,
		onChange,
	};

	return (
		<Autosuggest
			suggestions={suggestions}
			onSuggestionsFetchRequested={onSuggestionsFetchRequested}
			onSuggestionsClearRequested={onSuggestionsClearRequested}
			getSuggestionValue={getSuggestionValue}
			renderSuggestion={renderSuggestion}
			inputProps={inputProps}
			theme={theme}
		/>
	);
};

export default AutoComplete;
